import { render, staticRenderFns } from "./RejectCommentModal.vue?vue&type=template&id=b4ceeec8&scoped=true&"
import script from "./RejectCommentModal.vue?vue&type=script&lang=js&"
export * from "./RejectCommentModal.vue?vue&type=script&lang=js&"
import style0 from "./RejectCommentModal.vue?vue&type=style&index=0&id=b4ceeec8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ceeec8",
  null
  
)

export default component.exports